<template>
  <div class="section-enter-animation" :class="`section--${sectionName}`">
    <img
      v-if="section.backgroundImage"
      :src="section.backgroundImage"
      alt=""
      class="img-background"
    />

    <img
      v-if="singleImage"
      ref="img"
      class="img-wrapper img-wrapper--single"
      :class="`img-wrapper--${sectionName}`"
      :src="singleImage"
      alt=""
    />

    <div
      v-if="animationType === 'double'"
      :class="`img-wrapper--${sectionName}`"
      class="img-wrapper img-wrapper--double"
    >
      <img
        v-if="images[0]"
        ref="img1"
        class="img img--1"
        :src="images[0]"
        alt=""
      />

      <img
        v-if="images[1]"
        ref="img2"
        class="img img--2"
        :src="images[1]"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import throttle from 'raf-throttle'

export default {
  props: {
    section: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isActive() {
      return this.section.isActiveSection
    },
    sectionName() {
      return this.section.name
    },
    animationType() {
      return this.section.animation
    },
    images() {
      return this.section.images || []
    },
    singleImage() {
      return this.animationType === 'single' ? this.images[0] : ''
    }
  },
  watch: {
    isActive() {
      this.mousemoveHandler()
    }
  },
  mounted() {
    const throttleHandler = throttle(this.mousemoveHandler)
    document.addEventListener('mousemove', throttleHandler)

    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('mousemove', throttleHandler)
    })
  },
  methods: {
    mousemoveHandler(evt) {
      if (evt) this.$store.commit('updateLastClientX', evt.clientX)
      if (!this.isActive) return

      const clientX = evt ? evt.clientX : this.$store.state.lastClientX
      const relativeX = clientX / window.innerWidth

      if (this.animationType === 'single') {
        const { img } = this.$refs
        if (img)
          img.style.transform = `rotate3d(0, 1, 0, ${(relativeX - 0.5) *
            60}deg)`
      } else {
        const { img1, img2 } = this.$refs
        if (!img1 || !img2) return
        img1.style.transform = `rotate3d(0, 0, -1, ${10 +
          (relativeX - 0.5) * 20}deg)`
        img2.style.transform = `rotate3d(0, 0, 1, ${10 +
          (relativeX - 0.5) * 20}deg)`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.section-enter-animation {
  @include center-content(vertically);
  perspective: 50vw;

  @include hide-down(lg);
  flex-basis: 50%;

  margin-left: 50px;

  @include media-up(xl) {
    margin-left: 25px;
  }
}

.img-wrapper {
  height: 100%;
  width: 100%;

  &--double {
    @include center-content;
    max-height: 100%;

    & .img {
      height: auto;
      max-height: 1000px;
      max-width: 100%;

      transform-origin: center 80%;
      transform: rotate3d(0, 0, 1, 10deg);

      &--1 {
        z-index: 2;
        transform: rotate3d(0, 0, -1, 10deg);
      }
    }
  }

  &--loteria {
    & .img {
      &--1 {
        width: 13vw;
        margin-top: 5vw;
      }

      &--2 {
        width: 14vw;
        margin-left: -7.5vw;
      }
    }
  }

  &--podcast {
    width: 100%;
    height: auto;
  }

  &--jasne {
    justify-content: flex-start;
    align-items: flex-end;
    margin-left: 3vw;

    @include media-up(lg) {
      max-height: 500px;
    }

    @include media-up(xl) {
      max-height: 900px;
    }

    & .img {
      height: auto;

      &--1 {
        width: 43.5%;
        max-width: 186px;
      }

      &--2 {
        width: 57.5%;
        max-width: 245px;
        margin-bottom: 6%;
        margin-left: -5vw;
      }
    }
  }

  &--mural {
    object-fit: contain;
    max-height: 768px;
  }

  &--znani {
    @include media-up(lg) {
      object-fit: contain;
      max-height: 47%;
    }
  }

  &--loteria-zdrapkowa {
    & .img {
      &--1 {
        width: 45%;
        margin-right: -11vw;
        margin-bottom: -35%;

        @include media-up(xl) {
          width: 37%;
          margin-right: -10.3vw;
          margin-bottom: -24%;
        }
      }
      &--2 {
        width: 136%;
        max-width: none;

        @include media-up(xl) {
          width: 101.6%;
        }
      }
    }
  }
}

.img-background {
  @include center-self;
  width: 136%;
  height: auto;
  z-index: 0;
}
</style>
